// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { type LookAndFeelRootPropsCanceledPayment } from '@tectonics/look-and-feel';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

import { PageTemplate } from '../../commons/templates';
import { Separator } from '../../commons/atoms';
import { BackToAppButton } from '../commons/back-to-app-button';

import { ContextProvider } from './context-provider';
import CanceledSrc from './canceled-icon.svg';
import { MessagesContent } from '../commons/messages-content';

export function CanceledPaymentPage(props: LookAndFeelRootPropsCanceledPayment): Node {
  return (
    <ContextProvider {...props}>
      <PageTemplate data-test-id="page-canceled-payment">
        <Icon />
        <CanceledPaymentMessage />
        <BackToAppButton />
        <Separator size="0.4em" />
      </PageTemplate>
    </ContextProvider>
  );
}

function CanceledPaymentMessage(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return (
        <MessagesContent
          header="Este pagamento foi cancelado."
          messages={[
            'Acesse o aplicativo para ver mais detalhes sobre esse pagamento.',
            'Caso precise fazer outro pagamento, gere um novo pedido.',
          ]}
        />
      );

    case 'bo':
    case 'mx':
    case 'cl':
    case 'co':
    case 'pe':
    case 'ec':
    case 'ar':
      return (
        <MessagesContent
          header="Este pago fue cancelado."
          messages={[
            'Para conocer más detalles sobre este pago, acceda a la aplicación',
            'Si necessitas hacer otro pago, genere un nuevo pedido.',
          ]}
        />
      );

    default:
      throw new Error(`Canceled Payment Message not implemented for country ${country}`);
  }
}

function Icon(): Node {
  return (
    <IconWrapper>
      <img src={CanceledSrc} alt="canceled-icon" />
      <Separator size="1em" />
    </IconWrapper>
  );
}

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
